<template>
  <div class="app">
    <!-- <el-button type="primary">Primary</el-button>
    <el-button type="success">Success</el-button>
    <el-button type="info">Info</el-button>
    <el-button type="warning">Warning</el-button>
    <el-button type="danger">Danger</el-button> -->
    <router-view
      class="app_router_view"
      :style="{ zoom: mydata.zoom }"
    ></router-view>

    <!-- 弹窗不要了 -->
    <el-dialog :value="false" width="650">
    <!-- 弹窗 -->
    <!-- <el-dialog v-model="mydata.dialogVisible" width="650">
       -->
      <!-- <p v-html="mydata.configObj.home_dialog.value"></p> -->

      <p v-html="mydata.configObj?.home_dialog?.value"></p>

      <!-- <h1>网站公告</h1> -->
      <!-- <p>亲爱的老师们、同学们和家长们：</p>
      <p>欢迎大家来到&lt;天利38套考试研究网&gt;</p>

      <p>
        31年教育老厂为感谢这些年同学们、老师们、家长们对“天利38套”等系列图书的支持与喜爱，给大家准备了两重福利
      </p>
      <p>福利一：新用户注册即为会员用户</p>
      <p>- 参与条件：网站上线后新注册用户</p>
      <p>- 权益说明：全站精品淘题资源（持续更新）免费下载</p>

      <p>福利二：注册即领京东旗舰店无门槛金额直减优惠券</p>
      <p>- 参与条件：活动期间新注册用户</p>
      <p>- 奖励规则：注册成功即得京东旗舰店无门槛5元直减券（全品类图书可用）</p>
      <p>- 发放方式：优惠券通过站内信发放，用户点击站内信链接领取即可</p>

      <p style="margin-top:20px;">网站全新升级，相关了解请戳：</p> -->
      <!-- <a
        href="http://tianlipc_web.calf360.com/#/layout/list/enterpriseDetails?id=493" target="_self"
        >【天利38套考试研究网】教与学综合服务平台上线公告 --专注中高考提分31年，让优质教育更普惠可及</a
      > -->
      <!-- <router-link to="/layout/list/enterpriseDetails?id=493" @click="mydata.dialogVisible=false">【天利38套考试研究网】教与学综合服务平台上线公告 --专注中高考提分31年，让优质教育更普惠可及</router-link> -->
      <!-- （上线换正式文章链接） -->

      <el-button type="primary" round @click="signUp">立即注册</el-button>
      

      
    </el-dialog>
  </div>
</template>
<script setup>
import { nextTick, onMounted, reactive, ref, watch,onBeforeUnmount} from "vue";
import { useRoute, useRouter } from "vue-router";
//配置列表
import { getConfig } from "@/api/list/index.js";



const router = useRouter();
const mydata = reactive({
  zoom: 1,
  dialogVisible: false,

  configObj: {},
});

// 依赖注入
// provide("configObj", toRefs(mydata).configObj);


function pageZoom() {
  // 如果是移动端
  if (/Mobile/.test(navigator.userAgent)) {
    // 电脑屏幕宽度
    let screenWidth = window.document.body.clientWidth - 0;
    // 设计图的宽度
    let uiWidth = 375 - 0; // 滚动条占用了0px的宽度
    // 计算出应该缩放的比例
    let ratio = Number(screenWidth / uiWidth);
    // 绑定动态属性
    mydata.zoom = ratio;
  } else {
    // 电脑屏幕宽度
    let screenWidth = window.screen.width - 5; // 滚动条占用了5px的宽度
    // 设计图的宽度
    let uiWidth = 1920 - 5; // 滚动条占用了5px的宽度
    // 计算出应该缩放的比例
    let ratio = Number(screenWidth / uiWidth);
    // 绑定动态属性
    mydata.zoom = ratio;
  }
}


onMounted(() => {
  // 整体缩放
  nextTick(() => {
    pageZoom();
    changeWebUrl()
  });
  // 全体弹窗
  if (!localStorage.getItem("glDialog")) {
    mydata.dialogVisible = true;
    localStorage.setItem("glDialog", true);
  }

   // 监听页面宽度，改变网站地址
  window.addEventListener("resize",changeWebUrl)
});

onBeforeUnmount(()=>{
  window.removeEventListener("resize",changeWebUrl)
})

const route = useRoute();

watch(
  () => {
    return route.path;
  },
  (n, o) => {
    let title = document.getElementsByTagName("title")[0];
    title.innerHTML = route.meta.title
      ? route.meta.title
      : "天利38套考试研究网";
  },
  {
    immediate: true,
    deep: true,
  }
);

function signUp() {
  mydata.dialogVisible = false;
  router.push({
    path: "/loginRegister",
  });
}


// 获取配置数据
function getConfigFn() {
  getConfig().then((res) => {
    mydata.configObj = res.data;
    // console.log(res.data,"获取配置数据")
  });
}

getConfigFn();


// 改变网站地址
function changeWebUrl() {
  if (process.env.NODE_ENV === "development" || window.location.href.includes('/h5test') ) {
    return;
  }
  // let pcOrigin = 'http://tianlipc_web.calf360.com'
  // let appOrigin = 'http://tianli_m.calf360.com'
  /////// 暂时注释
  let pcOrigin = 'https://www.tl100.com'
  let appOrigin = 'https://mobile.tl100.com'
  // 如果是手机端宽度
  if (window.document.documentElement.clientWidth<600) {
    // 如果当前网址不是手机端网址，那么就跳转到手机端网址
    if (window.location.origin!==appOrigin) {
      window.location.href = appOrigin + "/#"+ route.fullPath
    }
  }
  // 如果是电脑端宽度
  else{
    //////// 暂时注释
    // 如果当前网址不是电脑端网址，那么就跳转到电脑端网址
    if (window.location.origin!==pcOrigin) {
      window.location.href = pcOrigin + "/#"+ route.fullPath
    }
  }
}


</script>

<style lang="scss" scoped>
//根组件
.app_router_view {
  min-width: 1920px;
  min-width: 1915px;
  margin: 0 auto;
  // background:#f9f9f9;
  // border: 1px solid cyan;
}

:deep(.el-dialog) {
  // border: 1px solid red;
  border-radius: 30px;
  background-color: #fff;
  .el-dialog__body {
    margin: 30px 20px 30px 20px;
    // border:1px solid red;
    > h1 {
      text-align: center;
      color: black;
      margin-bottom: 30px;
    }
    > p {
      // text-align: center;
      line-height: 26px;
    }

    .el-button.el-button--primary.is-round {
      width: 400px;
      height: 44px;
      margin: 0 auto;
      margin-top: 30px;
      display: block;
      // border:1px solid red;
      > span {
        font-size: 16px;
        letter-spacing: 1px;
      }
    }
  }
}
</style>
